import React from "react";
import "./style.scss";
import FilterIcon from "../../assets/images/debit_report/filter_icon.svg";
import HideIcon from "../../assets/images/debit_report/hide_icon.svg";
import PlusIcon from "../../assets/images/debit_report/plus_icon.svg";
import { Form, FormLabel } from "react-bootstrap";
import Select from "react-select";
import CommonButton from "../commonButton";
import moment from "moment";

export default function DebitFilter({
  filterOptions,
  dateRange,
  selectedOptions,
  handleChange,
  handleDateRangeChange,
  handleTransactionTypeChange,
  handleClearFilter,
  handleFilter,
  showFilter,
  setShowFilter,
}) {
  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <>
      <div className="debit-filter-container">
        <div className="debit-filter-wrapper" onClick={handleShowFilter}>
          {" "}
          <div className="d-flex align-items-center title-filter-wrapper">
            <img src={FilterIcon} alt="filter-icon" />
            <h5>Filter options</h5>
          </div>
          <div className="arrow-icon">
            <img src={showFilter ? HideIcon : PlusIcon} alt="hide-show-icon" />
          </div>
        </div>
        {showFilter && (
          <>
            <div className="debit-sub-filter-wrapper">
              <div className="debit-input-filter-wrapper">
                <FormLabel htmlFor="startDate">Start Date</FormLabel>
                <Form.Control
                  id="start_date"
                  type="date"
                  value={moment(selectedOptions.start_date).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={handleChange}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
              <div className="debit-input-filter-wrapper">
                <FormLabel htmlFor="endDate">End Date</FormLabel>
                <Form.Control
                  id="end_date"
                  type="date"
                  min={moment(selectedOptions.start_date).format("YYYY-MM-DD")}
                  value={moment(selectedOptions.end_date).format("YYYY-MM-DD")}
                  onChange={handleChange}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>
            <div className="debit-dropdown-filter-wrapper">
              <Select
                options={filterOptions}
                placeholder="Select transaction type"
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                value={
                  selectedOptions.transaction_type
                    ? {
                        label: selectedOptions.transaction_type,
                        value: selectedOptions.transaction_type,
                      }
                    : null
                }
                onChange={handleTransactionTypeChange}
              />
              <Select
                options={dateRange}
                placeholder="Select date range"
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                value={
                  selectedOptions.date_range
                    ? {
                        label: selectedOptions.date_range,
                        value: selectedOptions.date_range,
                      }
                    : null
                }
                onChange={handleDateRangeChange}
              />
            </div>
            <div className="filter-btn-wrapper">
              <CommonButton
                variant="primary"
                onClick={handleFilter}
                btnText="Apply Filter"
              />
              <CommonButton
                variant="tertiary"
                onClick={handleClearFilter}
                btnText="Clear Filter"
              />
            </div>
          </>
        )}
      </div>{" "}
    </>
  );
}
